import React from 'react';

export const TimePickerClockIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 8C15.3333 3.94991 12.0501 0.666667 8 0.666667C3.94991 0.666667 0.666667 3.94991 0.666667 8C0.666667 12.0501 3.94991 15.3333 8 15.3333ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#1477F8"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8 3.66667C8.1841 3.66667 8.33333 3.81591 8.33333 4V8H11.6667C11.8508 8 12 8.14924 12 8.33333C12 8.51743 11.8508 8.66667 11.6667 8.66667H8C7.81591 8.66667 7.66667 8.51743 7.66667 8.33333V4C7.66667 3.81591 7.81591 3.66667 8 3.66667Z" fill="#1477F8"/>
    </svg>

);
